import { eventTypeConstants } from './constants';
import { getGtmEventQueue } from './gtmEventQueue';
export const ABTEST_BUCKET_CUSTOM_EVENT = 'e_ab_bucket' as const;

export type AbTestBucketDecisions = {
    testName: string;
    testVariant: string;
};

/** these are MFA error codes */
type StepInteractionName =
    | 'MFA_REQUIRED'
    | 'MFA_CODE_EXPIRED'
    | 'MFA_INVALID_CODE'
    | 'MFA_CODE_ATTEMPTS_EXCEEDED'
    | 'SUSPICIOUS_ACTIVITY'
    | 'CREDENTIALS_ARE_LEAKED'
    | 'GOOGLE_LOGIN_ONLY'
    | 'FACEBOOK_LOGIN_ONLY'
    | 'APPLE_LOGIN_ONLY';

type StepType =
    | 'recaptcha_evaluation complete'
    // | 'recaptcha_evaluation error' // add this one?
    | 'MFA_challenge complete'
    | 'MFA_challenge entry';

export const trackCaptchaEvent = (
    captchaAction: string | null | undefined,
    captchaUuid: string | null | undefined,
    stepType: StepType,
    /** MFA error code or undefined */
    stepInteractionName?: StepInteractionName | null
): void => {
    getGtmEventQueue().push({
        event: eventTypeConstants.EVENT_EVENT,
        trigger: captchaAction,
        entry: captchaUuid,
        interaction_type: 'recaptcha',
        step_type: stepType,
        step_interaction_name: stepInteractionName,
    });
};
